import React, { useEffect } from "react";
import * as S from "./styled";
import subVisualInfo from "../../assets/subVisual/subVisualInfo.webp";
import InfoImage from "../../assets/images/aboutus/aboutusImg.webp";
import InfoSecondImage from "../../assets/images/aboutus/aboutusSecondImg.webp";
import InfoThirdImage from "../../assets/images/aboutus/aboutusThirdImg.webp";
import InfoFourthImage from "../../assets/images/aboutus/aboutusFourthImg.webp";

import SubVisual from "../../components/SubVisual";
import instagramIcon from "../../assets/images/common/instagram.png";
import youtubeIcon from "../../assets/images/common/youtube.png";
import callIcon from "../../assets/images/common/callIcon.png";
import homeIcon from "../../assets/images/common/homeIcon.png";
import kakaoIcon from "../../assets/images/common/kakao.png";
import locationIcon from "../../assets/images/common/locationIcon.png";
import { NavLink } from "react-router-dom";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const Info = () => {
  const handleCopyPhoneNumber = () => {
    const phoneNumber = "010-2351-8784";
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => {})
      .catch((err) => {
        console.error("복사 실패: ", err);
      });
  };
  const handleCopySecondPhoneNumber = () => {
    const phoneNumber = "010-5828-5559";
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => {})
      .catch((err) => {
        console.error("복사 실패: ", err);
      });
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.InfoContainer>
        <SubVisual
          src={subVisualInfo}
          title="협회 지부 안내"
          subTitle="협회 소개"
        />
        <S.InfoWrapper>
          <div className="inner">
            <S.InfoFlexWrapper>
              <S.InfoWrap>
                <div
                  className="img-wrap"
                  data-aos="fade-right"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <img src={InfoImage} alt="info" />
                </div>
                <div className="info-wrap">
                  <div className="title-wrap">
                    <p
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-easing="linear"
                    >
                      국제실용댄스지도자협회 협회장
                    </p>
                    <h6
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-delay={200}
                      data-aos-easing="linear"
                    >
                      박지원
                    </h6>
                  </div>
                  <div
                    className="icon-wrap"
                    data-aos="fade-left"
                    data-aos-duration={600}
                    data-aos-delay={500}
                    data-aos-easing="linear"
                  >
                    <div className="flex-col-wrap">
                      <NavLink
                        to="https://www.youtube.com/@Neptunedance"
                        target="_blank"
                      >
                        <img src={youtubeIcon} alt="sub visual" />
                      </NavLink>
                    </div>
                    <div className="flex-col-wrap">
                      <NavLink
                        to="https://www.instagram.com/ipdiakorea?igsh=MWIxYXBjd3RtMmFyZw=="
                        target="_blank"
                      >
                        <img src={instagramIcon} alt="sub visual" />
                      </NavLink>
                      <p>IPDIA</p>
                    </div>
                    <div className="flex-col-wrap">
                      <NavLink
                        to="https://www.instagram.com/neptuneseoul/profilecard/?igsh=MWN6Yml1MmUxMnZtZw=="
                        target="_blank"
                      >
                        <img src={instagramIcon} alt="sub visual" />
                      </NavLink>
                      <p>NEPTUNE</p>
                    </div>
                  </div>
                  <div
                    className="kakao-wrap"
                    data-aos="fade"
                    data-aos-duration={800}
                    data-aos-delay={800}
                    data-aos-easing="linear"
                  >
                    <div className="location-text-wrap">
                      <p>
                        서울 본부센터
                        <br />
                        넵튠댄스스튜디오 <br />
                        NEPTUNE DANCE STUDIO
                      </p>
                      <div className="location-icon-wrap">
                        <NavLink
                          to="https://neptunedance.com/contactus"
                          target="_blank"
                        >
                          <img src={locationIcon} alt="icon" />
                        </NavLink>

                        <button
                          onClick={handleCopyPhoneNumber}
                          className="pc-button"
                        >
                          <img src={callIcon} alt="icon" />
                        </button>
                        <a href="tel:010-2351-8784" className="mobile-button">
                          <img src={callIcon} alt="icon" />
                        </a>
                        <NavLink to="https://neptunedance.com/ " target="_blank">
                          <img src={homeIcon} alt="icon" />
                        </NavLink>
                      </div>
                    </div>
                    <NavLink
                      className="kakao-button-wrap"
                      to="http://pf.kakao.com/_xdxcJZn"
                      target="_blank"
                    >
                      <img src={kakaoIcon} alt="sub visual" />
                      <p>카카오 문의하기</p>
                    </NavLink>
                  </div>
                </div>
              </S.InfoWrap>
              <S.InfoWrap>
                <div
                  className="img-wrap"
                  data-aos="fade-right"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <img src={InfoFourthImage} alt="info" />
                </div>
                <div className="info-wrap">
                  <div className="title-wrap">
                    <p
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-easing="linear"
                    >
                      국제실용댄스지도자협회 남양주지부장
                    </p>
                    <h6
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-delay={200}
                      data-aos-easing="linear"
                    >
                      공정의
                    </h6>
                  </div>
                  <div
                    className="icon-wrap"
                    data-aos="fade-left"
                    data-aos-duration={600}
                    data-aos-delay={500}
                    data-aos-easing="linear"
                  >
                    <NavLink
                      to="https://www.instagram.com/re.shuffler?igsh=MXJobHdqdno3MXlucA=="
                      target="_blank"
                    >
                      <img src={instagramIcon} alt="sub visual" />
                    </NavLink>
                  </div>
                  <div
                    className="kakao-wrap"
                    data-aos="fade"
                    data-aos-duration={800}
                    data-aos-delay={800}
                    data-aos-easing="linear"
                  >
                    <div className="location-text-wrap">
                      <p>
                        남양주 지부
                        <br />
                        리버스댄스하우스
                        <br />
                        <span>
                          경기도 남양주시 경춘로490 1동 B1층 1129호
                          (힐스테이트지금디포레)
                        </span>
                      </p>
                      <div className="location-icon-wrap">
                        <NavLink to="https://naver.me/FqIIzcu0" target="_blank">
                          <img src={locationIcon} alt="icon" />
                        </NavLink>
                        <button
                          onClick={handleCopySecondPhoneNumber}
                          className="pc-button"
                        >
                          <img src={callIcon} alt="icon" />
                        </button>
                        <a href="tel:010-2751-2342" className="mobile-button">
                          <img src={callIcon} alt="icon" />
                        </a>
                        {/* <NavLink to="https://neptunedance.com/ " target="_blank">
                      <img src={homeIcon} alt="icon" />
                    </NavLink> */}
                      </div>
                    </div>
                    <NavLink
                      className="kakao-button-wrap"
                      to="http://pf.kakao.com/_VSxnsX"
                      target="_blank"
                    >
                      <img src={kakaoIcon} alt="sub visual" />
                      <p>카카오 문의하기</p>
                    </NavLink>
                  </div>
                </div>
              </S.InfoWrap>
              <S.InfoWrap>
                <div
                  className="img-wrap"
                  data-aos="fade-right"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <img src={InfoThirdImage} alt="info" />
                </div>
                <div className="info-wrap">
                  <div className="title-wrap">
                    <p
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-easing="linear"
                    >
                      국제실용댄스지도자협회 경기광주지부장
                    </p>
                    <h6
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-delay={200}
                      data-aos-easing="linear"
                    >
                      김혜경
                    </h6>
                  </div>
                  <div
                    className="icon-wrap"
                    data-aos="fade-left"
                    data-aos-duration={600}
                    data-aos-delay={500}
                    data-aos-easing="linear"
                  >
                    <NavLink
                      to="https://www.instagram.com/burningdancestudio_kkeng"
                      target="_blank"
                    >
                      <img src={instagramIcon} alt="sub visual" />
                    </NavLink>
                  </div>
                  <div
                    className="kakao-wrap"
                    data-aos="fade"
                    data-aos-duration={800}
                    data-aos-delay={800}
                    data-aos-easing="linear"
                  >
                    <div className="location-text-wrap">
                      <p>
                        경기광주 지부
                        <br />
                        버닝댄스스튜디오 BURNING DANCE STUDIO
                        <br />
                        <span>경기 광주시 고산길 17-2 2층 201호</span>
                      </p>
                      <div className="location-icon-wrap">
                        <NavLink to="https://naver.me/531NeYlf" target="_blank">
                          <img src={locationIcon} alt="icon" />
                        </NavLink>
                        <button
                          onClick={handleCopySecondPhoneNumber}
                          className="pc-button"
                        >
                          <img src={callIcon} alt="icon" />
                        </button>
                        <a href="tel:010-8823-4794" className="mobile-button">
                          <img src={callIcon} alt="icon" />
                        </a>
                        {/* <NavLink to="https://neptunedance.com/ " target="_blank">
                      <img src={homeIcon} alt="icon" />
                    </NavLink> */}
                      </div>
                    </div>
                    <NavLink
                      className="kakao-button-wrap"
                      to="https://pf.kakao.com/_bxhDIX"
                      target="_blank"
                    >
                      <img src={kakaoIcon} alt="sub visual" />
                      <p>카카오 문의하기</p>
                    </NavLink>
                  </div>
                </div>
              </S.InfoWrap>
              <S.InfoWrap>
                <div
                  className="img-wrap"
                  data-aos="fade-right"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <img src={InfoSecondImage} alt="info" />
                </div>
                <div className="info-wrap">
                  <div className="title-wrap">
                    <p
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-easing="linear"
                    >
                      국제실용댄스지도자협회 대전지부장
                    </p>
                    <h6
                      data-aos="fade-left"
                      data-aos-duration={600}
                      data-aos-delay={200}
                      data-aos-easing="linear"
                    >
                      서 정
                    </h6>
                  </div>
                  <div
                    className="icon-wrap"
                    data-aos="fade-left"
                    data-aos-duration={600}
                    data-aos-delay={500}
                    data-aos-easing="linear"
                  >
                    <NavLink
                      to="https://www.instagram.com/shuffle_seojung?igsh=MTdsbzhqM2xnYWhqeA=="
                      target="_blank"
                    >
                      <img src={instagramIcon} alt="sub visual" />
                    </NavLink>
                  </div>
                  <div
                    className="kakao-wrap"
                    data-aos="fade"
                    data-aos-duration={800}
                    data-aos-delay={800}
                    data-aos-easing="linear"
                  >
                    <div className="location-text-wrap">
                      <p>
                        대전지부
                        <br />
                        투비셔플 TOBE SHUFFLE
                        <br />
                        <span>대전 유성구 은구비남로 41 502호</span>
                      </p>
                      <div className="location-icon-wrap">
                        {/* <NavLink
                      to="https://neptunedance.com/contactus"
                      target="_blank"
                    >
                      <img src={locationIcon} alt="icon" />
                    </NavLink> */}
                        <button
                          onClick={handleCopySecondPhoneNumber}
                          className="pc-button"
                        >
                          <img src={callIcon} alt="icon" />
                        </button>
                        <a href="tel:010-5828-5559" className="mobile-button">
                          <img src={callIcon} alt="icon" />
                        </a>
                        {/* <NavLink to="https://neptunedance.com/ " target="_blank">
                      <img src={homeIcon} alt="icon" />
                    </NavLink> */}
                      </div>
                    </div>
                    <NavLink
                      className="kakao-button-wrap"
                      to="https://pf.kakao.com/_SxeDnn"
                      target="_blank"
                    >
                      <img src={kakaoIcon} alt="sub visual" />
                      <p>카카오 문의하기</p>
                    </NavLink>
                  </div>
                </div>
              </S.InfoWrap>
            </S.InfoFlexWrapper>
          </div>
        </S.InfoWrapper>
      </S.InfoContainer>
    </>
  );
};

export default Info;
